import { useEffect, useState } from "react";
import TableAction from "../../TableAction";
import { useDeleteWarehouse, useWarehouseList } from "../../../api/admin";
import {
  Button,
  FloatButton,
  Input,
  message,
  Modal,
  Popover,
  Table,
} from "antd";
import CreateWareHouseModal from "../../modals/CreateWarehouseModal";
import { useAuth, AuthContextValue } from "../../../providers/AuthProvider";
import { MoreOutlined, PlusOutlined } from "@ant-design/icons";
import { getStatusColor } from "../../../util/statusColor";

const WarehouseTable = () => {
  const { user } = useAuth() as AuthContextValue;
  const [tableData, setTableData] = useState<any[]>([]);
  const { mutateAsync: deleteCenter } = useDeleteWarehouse();
  const [searchText, setSearchText] = useState("");
  const [open, setOpen] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedCenterId, setSelectedCenterId] = useState<number>();
  const { data, isLoading } = useWarehouseList();
  const [wareHouses, setWareHouses] = useState([]);

  const handleCreate = () => {
    setSelectedCenterId(undefined);
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
    setSelectedCenterId(undefined);
  };

  const handleDelete = async () => {
    if (selectedCenterId && user?.mfiId && user.token) {
      try {
        const result = await deleteCenter(selectedCenterId);
        message.success("Warehouse is deleted successfully.");
      } catch (err: any) {
        message.error("Operation failed");
      } finally {
        setOpenDeleteModal(false);
      }
    }
  };

  const columns = [
    {
      dataIndex: "centerName",
      title: "Center Name",
    },
    {
      dataIndex: "centerNo",
      title: "Center No",
    },
    {
      dataIndex: "capacity",
      title: "Capacity",
    },
    {
      dataIndex: "location",
      title: "Location",
    },
    {
      dataIndex: "id",
      title: "Actions",
      render: (item: number, record: any) => {
        return (
          <div className="flex gap-2">
            <Button
              type="primary"
              onClick={() => {
                setSelectedCenterId(item);
                setOpen(true);
              }}
            >
              Edit
            </Button>
            {/* <Button onClick={() => {
                            setSelectedCenterId(item);
                            setOpenDeleteModal(true);
                        }}>Delete</Button> */}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    if (data && data.data && data.data.data) {
      const _data = data.data.data;

      if (searchText) {
        const filterData = _data.filter(
          (item: any) =>
            item.centerName?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.centerNo?.toLowerCase().includes(searchText.toLowerCase()) ||
            //  item.capacity?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.location?.toLowerCase().includes(searchText.toLowerCase())
        );
        setTableData(filterData);
      } else {
        setTableData(_data);
      }
    }
  }, [data, searchText]);

  return (
    <>
      <div className="hidden md:block rounded-xl mt-[25px] px-[50px] pt[22px] bg-white">
        <Modal
          open={openDeleteModal}
          centered
          onOk={handleDelete}
          title={<div className="text-black">Delete confirmation</div>}
          // okButtonProps={{ disabled: isPending }}
          onCancel={() => setOpenDeleteModal(false)}
          closable
        >
          <div className="text-black">
            Are you sure you want to delete the selected warehouse?
          </div>
        </Modal>
        <CreateWareHouseModal
          open={open}
          hideModal={hideModal}
          selectedId={selectedCenterId}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: 80,
            backgroundColor: "#EEF3F8",
            borderRadius: 8.4,
            marginBottom: 12,
          }}
        >
          <TableAction
            setSearchText={setSearchText}
            onCreateNew={handleCreate}
          />
        </div>
        <Table
          style={{
            cursor: "pointer",
            position: "relative",
            zIndex: 100,
            overflowY: "hidden",
          }}
          scroll={{ y: 600 }}
          dataSource={tableData}
          columns={columns}
          loading={isLoading}
        />
      </div>

      <div className="w-full grid grid-col divide-y-2 divide-green-400 md:hidden px-2 mb-4">
        <div className="text-white sticky top-0">
          <Input
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search"
            style={{ backgroundColor: "#08453E", color: "white", height: 40 }}
          />
        </div>
        {tableData?.map((item: any) => (
          <div key={item.id} className="flex justify-between items-center py-2">
            <div className="flex flex-col gap-1">
              <div className="flex gap-4 font-bold text-xl text-white">
                <div>{item.centerName}</div>
                <div>({item.centerNo})</div>
              </div>
              <div className="text-gray-300">{`Capacity - ${item.capacity}`}</div>
              <div className="text-gray-300">{`Location - ${item.location}`}</div>
            </div>
            <Popover
              placement="bottomLeft"
              title={<div style={{ color: "black" }}>Actions</div>}
              content={
                <div style={{ color: "black", width: 200 }}>
                  <div>
                    <div
                      onClick={() => {
                        setSelectedCenterId(item.id);
                        setOpen(true);
                      }}
                    >
                      Edit
                    </div>
                  </div>
                </div>
              }
            >
              <MoreOutlined className="text-white" />
            </Popover>
            <FloatButton
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleCreate}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default WarehouseTable;
